export const UPDATE_MESSAGE_RESPONSE: Record<string, string> = {
    INCORRECT_CURRENT_PASSWORD: 'Mật khẩu hiện tại chưa đúng!',
    INVALID_PHONE_NUMBER:'Số điện thoại đã tồn tại',
    EMAIL_OR_USERNAME_EXISTS: 'Email hoặc tên đăng nhập đã tồn tại',
    FULL_NAME_MUST_BE_AT_LEAST_8_CHARACTERS_NOT_MORE_THAN_100_CHARACTERS:'Họ tên phải ít nhất 8 ký tự, không vượt quá 100 ký tự',
    USERNAME_MUST_BE_AT_LEAST_6_CHARACTERS_NOT_MORE_THAN_50_CHARACTERS:'Tên đăng nhập phải ít nhất 6 ký tự, không vượt quá 50 ký tự',
    INVALID_EMAIL:'Email không hợp lệ',
    INVALID_NEW_PASSWORD:'Password không hợp lệ'
}